// Horizontal Pamosi lockup — the P-tile from public/logo.svg + the
// "Pamosi" wordmark. Used in the login card and the authed top bar.
// `size` controls the tile edge in px; text scales off that so the whole
// lockup keeps its proportions at any callsite.

export function Logo({ size = 28, showWordmark = true }: { size?: number; showWordmark?: boolean }) {
    return (
        <div className="flex items-center gap-2">
            <img
                src="/logo.svg"
                alt="Pamosi"
                width={size}
                height={size}
                className="rounded-md"
                style={{ width: size, height: size }}
            />
            {showWordmark && (
                <span
                    className="font-semibold text-slate-900 tracking-tight"
                    style={{ fontSize: Math.round(size * 0.72) }}
                >
                    Pamosi
                </span>
            )}
        </div>
    );
}
